import Base from 'layouts/Base';
import EducationArticlesTemplate from '../templates/EducationArticlesTemplate';

function EducationArticlesListing() {
    return (
        <Base title="Educação" link="/educacao">
            <EducationArticlesTemplate />
        </Base>
    );
}

export default EducationArticlesListing;
